
/* injects from baggage-loader */

'use strict';

import CreateProductVariantModalController from './createProductVariantModal.controller';
import CreateProductVariantModalTemplate from './createProductVariantModal.html';

export default class CreateProductVariantModalComponent {
		constructor() {
				this.templateUrl = CreateProductVariantModalTemplate;
				this.controller = CreateProductVariantModalController;
				this.controllerAs = 'ctrl';
				// Bind resolved items to the controller, see module state for resolve
				this.bindings = {
					resolve: '<',
					close: '&',
					dismiss: '&'
				};
		}
}



// WEBPACK FOOTER //
// ./src/app/components/createProductVariantModal/createProductVariantModal.component.js